module.exports = __webpack_public_path__ + "img/heroku.473972c7.png";